import { render, staticRenderFns } from "./OasisSoftware.vue?vue&type=template&id=2e099ab1"
import script from "./OasisSoftware.vue?vue&type=script&lang=js"
export * from "./OasisSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports